<template>
  <div id="app">
    <router-view />
  </div>
</template>


<script>
import { checkToken } from '@/api/study.js';
import { mapMutations } from 'vuex';
export default {
  methods: {
    ...mapMutations('m_user', ['updateToken'])
  },
  mounted() {
    setTimeout(() => {
      if (this.$route.query.token) {
        checkToken({ token: this.$route.query.token }).then(res => {
          console.log(res.data.data.checkToken);
          //检测token能不能用，能用再存储
          if (res.data.data.checkToken) {
            // 拿到密钥存在本地存储
            this.updateToken(this.$route.query.token);
            //拿到密钥存在本地存储;
            localStorage.setItem('token', this.$route.query.token);
          }
          // this.checkUserQuizs();
        });
      } else {
        // this.checkUserQuizs();
      }
    }, 500);
  },
  created() {
    const ua = window.navigator.userAgent;
    // IE 11 标识 | IE 10 及以下标识 | 旧版 Edge (EdgeHTML)
    if (ua.indexOf('Trident') > -1 || ua.indexOf('MSIE') > -1 || ua.indexOf('Edge/') > -1) {
      this.$confirm('您所使用的浏览器版本过低，可能会导致显示不正常，请切换为急速模式获得更好的体验！', '温馨提示', {
        confirmButtonText: '确定',
        type: 'info'
      })
        .then(() => {
          
        })
        .catch(() => {
          
        });
    }
  }
};
</script>
<style lang="less">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: Regular;
}
input {
  outline: none;
}
.el-notification {
  cursor: pointer;
}
#app {
}
</style>
